var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"session__show_people_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: ['firstName', 'lastName'],
                title: 'Name',
                type: 'string',
                sortable: true
            },
            {
                key: 'email',
                title: 'Email',
                type: 'string',
                sortable: true
            },
            {
                key: 'bookingStatus',
                title: 'Status',
                type: 'string',
                sortable: true
            },
            {
                key: 'actions',
                title: '',
                type: '',
                sortable: false
            }
        ],"items":_vm.items,"component-table-item":_vm.SessionShowPeopleTableItem},on:{"emit-view-booking-form":_vm.emitViewBookingForm,"emit-remove-from-waitlist":_vm.emitRemoveFromWaitlist,"emit-invite-person":_vm.emitInvitePerson,"emit-book-person":_vm.emitBookPerson,"emit-cancel-invite":_vm.emitCancelInvite,"emit-resend-invite":_vm.emitResendInvite,"emit-decline-booking":_vm.emitDeclineBooking,"emit-approve-booking":_vm.emitApproveBooking,"emit-cancel-booking":_vm.emitCancelBooking,"emit-view-cancellation":_vm.emitViewCancellation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }